import { Component, Prop, Vue, PropSync } from 'vue-property-decorator'
import bus from '@/app/bus'

@Component
export default class ContextDiagramSelect extends Vue {

    @Prop()
    public items?: any

    @Prop()
    public select?: any

    public compSelect = this.select

    public changeRoute(a: any) {
        this.$router.push(a)
        if (this.$route.params.type === "action"
        || this.$route.params.type === "topic"
        || this.$route.params.type === "stakeholder") {
            bus.$emit("reload-spider")
        }
    }
}
